/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable quotes */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { membraneStyle } from './ro-unit-style';
import SubLine from '../createLine';
import { ArialB600, ChineseFonts, RationValWidth, getFloatVal } from '../fonts/font';
import TableHeader from '../header';
import { defaultUnitSetDict } from '../../../shared/constantVariable';

const borderColor = '#B3D3D7';
let tablewidth = 1140;
let headercount = 1;
let rowWidthInc = 3;
let defaultUnit = defaultUnitSetDict();
let ro_hp_ind = 0;
const dataArray = [
  { key: 'Ca++', key1: 'Ca++', key2: 'Ca++', key3: 'ppm_dict' },
  { key: 'Mg++', key1: 'Mg++', key2: 'Mg++', key3: 'ppm_dict' },
  { key: 'Na+', key1: 'Na+', key2: 'Na+', key3: 'ppm_dict' },
  { key: 'K+', key1: 'K+', key2: 'K+', key3: 'ppm_dict' },
  { key: 'NH4+', key1: 'NH4+', key2: 'NH4+', key3: 'ppm_dict' },
  { key: 'Ba++', key1: 'Ba++', key2: 'Ba++', key3: 'ppm_dict' },
  { key: 'Sr++', key1: 'Sr++', key2: 'Sr++', key3: 'ppm_dict' },
  { key: 'Fe++', key1: 'Fe++', key2: 'Fe++', key3: 'ppm_dict' },
  { key: 'Mn++', key1: 'Mn++', key2: 'Mn++', key3: 'ppm_dict' },
  { key: 'SO4--', key1: 'SO4--', key2: 'SO4--', key3: 'ppm_dict' },
  { key: 'Cl-', key1: 'Cl-', key2: 'Cl-', key3: 'ppm_dict' },
  { key: 'F-', key1: 'F-', key2: 'F-', key3: 'ppm_dict' },
  { key: 'NO3-', key1: 'NO3-', key2: 'NO3-', key3: 'ppm_dict' },
  { key: 'Br-', key1: 'Br-', key2: 'Br-', key3: 'ppm_dict' },
  { key: 'PO4---', key1: 'PO4---', key2: 'PO4---', key3: 'ppm_dict' },
  { key: 'B', key1: 'B-', key2: 'B-', key3: 'ppm_dict' },
  { key: 'SiO2', key1: 'SiO2', key2: 'SiO2', key3: 'ppm_dict' },
  { key: 'H2S', key1: 'H2S', key2: 'H2S', key3: 'ppm_dict' },
  { key: 'HCO3-', key1: 'HCO3-', key2: 'HCO3-', key3: 'ppm_dict' },
  { key: 'CO2', key1: 'CO2', key2: 'CO2', key3: 'ppm_dict' },
  { key: 'CO3--', key1: 'CO3--', key2: 'CO3--', key3: 'ppm_dict' },
  { key: 'TDS', key1: 'feed_tds', key2: 'tds', key3: 'prop_dict' },
  { key: 'pH', key1: 'feed_ph', key2: 'ph', key3: 'prop_dict' },
  { key: `Pi, ${defaultUnit.Pressure ? defaultUnit.Pressure : 'bar'}`, key1: 'feed_pi', key2: 'osmotic_pressure', key3: 'sat_indices' },
  { key: 'Conductivity', key1: 'feed_cond', key2: 'conductivity', key3: 'sat_indices' },
  { key: 'Hardness, ppm as CaCO3', key1: 'feed_hardness', key2: 'hardness', key3: 'prop_dict' },
  { key: 'Density, kg/m3', key1: 'feed_density', key2: 'density', key3: 'prop_dict' },
  { key: 'Ionic Str', key1: 'feed_is', key2: 'ionic_str', key3: 'prop_dict' }
];

const ROStageLevelSummary = (props) => {
  const { system_units, rodata, ro_summary, tableWidth, pageWidth, serialNum, langualgeCheck, translateObject } = props;
  let { subSerialNum } = props;
  const { ro_stage_dict, ro_system_dict, aggregated_stream_data } = ro_summary;
  defaultUnit = system_units || defaultUnit;
  tablewidth = tableWidth;
  const herder_val = [
    translateObject('Stage'),
    translateObject('Housing'),
    translateObject('Elements'),
    translateObject('Element Type'),
    { header1: `${translateObject('Flow')} (${defaultUnit['Volume Flow']})`, header2: [translateObject('Feed'), translateObject('Conc.'), translateObject('Perm.')] },
    `${translateObject('Recovery')}                (%)`,
    `${translateObject('Flux')}                    (${defaultUnit.Flux})`,
    { header1: `${translateObject('Pressure')} (${defaultUnit.Pressure})`, header2: [translateObject('Feed'), translateObject('dP')] },
    { header1: `${translateObject('TDS')} (mg/L)`, header2: [translateObject('Feed'), translateObject('Perm.')] },
    translateObject('Last Element Beta')
  ];
  const getSingleRowWidth = (count) => {
    if (count) {
      return RationValWidth((tablewidth / headercount) * rowWidthInc / count - 2);
    }
    return RationValWidth(tablewidth / headercount) * rowWidthInc;
  };
  headercount = herder_val.length;
  const splitHeaderData = (ele) => {
    // const count = Object.keys(data).length + 1;
    return Object.prototype.toString.call(ele) === '[object Array]' ? (
      ele.map((dta, ind) => (
        <View key={ind}
          style={[
            { width: getSingleRowWidth(ele.length), borderTop: 1, borderLeft: 1, borderColor, justifyContent: 'center' },
            ind === 0 && { borderLeft: 0 },
          ]}
        >
          <Text
            style={[
              membraneStyle.tableCell, membraneStyle.restChild, langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }
            ]}
          >
            {translateObject(dta)}
          </Text>
        </View>
      ))
    ) : (
      <View style={{ width: '100%', justifyContent: 'center' }}>
        <Text
          style={[membraneStyle.tableCell, membraneStyle.restChild, langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }]}
        >
          {translateObject(ele)}
        </Text>
      </View>
    );
  };
  const getColumnCount = (ele) => {
    let count = 1;
    if (Object.prototype.toString.call(ele) === '[object Object]') {
      Object.keys(ele).map((data) => {
        if (Object.prototype.toString.call(ele[data]) === '[object Array]') {
          if (count < ele[data].length) {
            count = ele[data].length;
          }
        }
        return count;
      });
    }
    return count;
  };
  const createHeader = (item) => {
    return (
      <View style={[membraneStyle.tableRow, { width: RationValWidth(tablewidth) }]}>
        {item.map((ele, ind) => {
          rowWidthInc = getColumnCount(ele);
          return (
            <View key={ind}
              style={[
                membraneStyle.tableCol, { borderColor },
                ind === item.length - 1 && { borderRight: 0 },
                { width: RationValWidth((tablewidth / headercount)) },
                Object.prototype.toString.call(ele) === '[object Object]' && Object.keys(ele).length > 1 &&
                { width: getSingleRowWidth() }
              ]}
            >
              {Object.prototype.toString.call(ele) === '[object Object]' ? (
                Object.keys(ele).map((data, keyInd) => (
                  <View key={keyInd} style={[membraneStyle.flexDirection]} >
                    {splitHeaderData(ele[data], ele)}
                  </View>
                ))
              ) : (
                <View>
                  <Text style={[membraneStyle.tableCell, membraneStyle.restChild, langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }]}>
                    {translateObject(ele)}
                  </Text>
                </View>
              )}
            </View>
          );
        })
        }
      </View >
    );
  };
  const createContent = (items, parentkey) => {
    return (
      <View style={{ width: '100%' }}>
        {Object.keys(items).map((stage, typeindex) => {
          return (
            <View
              style={[
                membraneStyle.tablebodyRow1, { width: RationValWidth(tablewidth), margin: '0 auto' }
              ]}
              key={typeindex}
            >
              <View
                style={[
                  membraneStyle.flexDirection,
                  { width: RationValWidth(tablewidth) }
                ]}>
                <View style={[membraneStyle.tablebodyCol1]}>
                  <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}, { padding: '5 0' }]}>{translateObject(stage)}</Text>
                </View>
                {/* {Object.keys(items[stage]).map((data, ind) => { */}
                {['Housing', 'Elements', 'Element Type', 'Flow', 'Conc.', 'Perm.', '% Recovery', 'Flux', 'Feed Pressure', 'Pressure dp', 'Feed TDS mg/L', 'Perm TDS mg/L', 'Last Elem Beta'].map((data, ind) => {
                  return (
                    <View key={ind} style={[membraneStyle.tablebodyCol1, Object.keys(items[stage]).length - 1 === ind && { borderRight: 0 }]}>
                      {(() => {
                        if (data === 'Element Type') {
                          if (rodata[parentkey] && rodata[parentkey]['grid-data'] && rodata[parentkey]['grid-data'][typeindex] && rodata[parentkey]['grid-data'][typeindex].elementModel) {
                            return (
                              <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>
                                {rodata[parentkey]['grid-data'][typeindex].elementModel.split("").map((text, textInd) => {
                                  return <Text key={textInd}>{text}</Text>;
                                })}
                              </Text>
                            );
                          }
                          return (
                            <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>
                              {(() => {
                                if (rodata[parentkey]) {
                                  return rodata[parentkey]['grid-data'][0].elementModel.split("").map((text, textInd) => {
                                    return <Text key={textInd}>{text}</Text>;
                                  });
                                }
                                return '-';
                              })()}
                            </Text>
                          );
                        }
                        if (data === 'Flux' && defaultUnit.Flux === 'm/s') {
                          return (
                            <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>{(items[stage][data]).toExponential(2)}</Text>
                          );
                        }
                        const val = items[stage][data].toString();
                        if (val.indexOf('.') >= 0) {
                          return (
                            <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>{translateObject(getFloatVal(items[stage][data]))}</Text>
                          );
                        }
                        return (<Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>{translateObject(items[stage][data])}</Text>);
                      })()}
                    </View>
                  );
                })}
              </View>
            </View>
          );
        })}
      </View >
    );
  };
  return (
    <View id='dynamic-height'>
      <View style={[membraneStyle.mainHeader, { width: RationValWidth(pageWidth) }]}>
        <Text style={{ ...(langualgeCheck ? { fontFamily: ChineseFonts } : {}) }}>{serialNum}. {translateObject('RO/NF Unit Stage-Level Summary')}</Text>
        <SubLine lineWidth='100%' lineHeight='24' />
        {/* I reduced the line width to accommodate the text and added a margin left. --->kranthi */}
      </View>
      <View style={[membraneStyle.textHeader, { width: RationValWidth(pageWidth), marginTop: 15, flexDirection: 'row' }]} /* bookmark={{ title: `${serialNum}.${subSerialNum} Docked Summary ` }} */ >
        {/* <SubLine lineWidth='10px' lineHeight='12' /> */}
        {/* <Text style={{ marginTop: -4, paddingLeft: 5, color: '#0062A9' }}>&#95;&#95;</Text> */}
        <Text style={{ paddingLeft: 0 }}>{serialNum}.{subSerialNum}</Text>
        <Text style={{ paddingLeft: 5, ...(langualgeCheck ? { fontFamily: ChineseFonts } : {}) }}>{translateObject('Docked Summary')}</Text>
      </View>
      {ro_system_dict['RO/NF Unit ID'].length > 0 && ro_system_dict['RO/NF Unit ID'].map((ele, ind) => {
        if (ele.toLocaleLowerCase().indexOf('ro') >= 0 || ele.toLocaleLowerCase().indexOf('nf') >= 0) {
          return (
            <View key={`a${String(Math.random()).substring(2, 7)}`} style={{ width: RationValWidth(tablewidth), margin: '15 auto 0 auto' }}>
              <View break>
                <View style={[membraneStyle.textHeader, { flexDirection: 'row' }]}>
                  <Text style={{ paddingLeft: 0 }}>{serialNum}.{subSerialNum}.{++ro_hp_ind}</Text>
                  <Text style={{ paddingLeft: 5, ...(langualgeCheck ? { fontFamily: ChineseFonts } : {}) }}>{ele} {translateObject('Array Design')} </Text>
                </View>
                <View style={[membraneStyle.mainTable, { marginTop: 10 }]}>
                  {createHeader(herder_val)}
                  {createContent(ro_stage_dict[ele].Stage, ele)}
                </View>
              </View>
            </View>
          );
        }
        return (<Text key={`k${String(Math.random()).substring(2, 7)}`} />);
      })}
      {ro_system_dict['RO/NF Unit ID'].length > 0 && ro_system_dict['RO/NF Unit ID'].map((ele, ind) => { // Check if RO/NF Unit ID array has elements and map through each unit
        let elemRowData = []; // Initialize an empty array to store row data for the table
        let aggregatedTotalData = aggregated_stream_data.filter((aggre) => {
          return aggre.name === ele;
        });
        aggregatedTotalData = aggregatedTotalData[0];
        if (ele.toLocaleLowerCase().indexOf('ro') === 0) { // Check if the element name contains 'rohp' (case-insensitive)
          const concentrate_stages = Object.values(ro_stage_dict[ele].Stage).map((_, idx) => `Stage ${idx + 1}`); // Create an array of stage names like ['Stage 1', 'Stage 2', ...]
          let parameterStage = [...concentrate_stages];
          if (aggregatedTotalData.split_flow) {
            parameterStage = parameterStage.flatMap(item => {
              if (item === 'Stage 1') {
                return ['Stage 1 Upstream', 'Stage 1 Downstream'];
              }
              return item;
            });
          }
          const table2Header = [ // Define the table header structure with nested columns
            "Parameter", // Empty first column for row labels
            "Feed", // Feed column header
            { tab: "Concentrate", tab2: concentrate_stages }, // Concentrate header with sub-columns for each stage
            { tab: "Permeate", tab2: [...parameterStage, "Mixed"] } // Permeate header with sub-columns for each stage
          ];
          const columnLength = ['', 'Feed', ...concentrate_stages, ...parameterStage, "Mixed"]; // Create a flat array of all column names for width calculation
          const ro_output_data = JSON.parse(localStorage.getItem('ro_ouput_data')); // Retrieve RO output data from localStorage and parse it
          const stream_ouput_data = JSON.parse(localStorage.getItem('stream_ouput_data')); // Retrieve stream output data from localStorage and parse it
          const downStream = stream_ouput_data[aggregatedTotalData.product]; // Get the specific stream output data for the current aggregated index
          elemRowData = dataArray.map((d_ele, d_ind) => { // Map through dataArray to create rows of data
            const finalObj = [d_ele.key]; // Initialize row with the key (parameter name) as first element
            const permValue = []; // Initialize array to store permeate values for all stages
            const constValue = [];
            ro_output_data[ele].output_user.stage.map((stage_ele, stage_ind) => { // Map through each stage in the RO output data
              if (stage_ind === 0) { // Check if this is the first stage
                const feedval = stage_ele.feed_ppm[d_ele.key1]; // Get the feed value for the current parameter
                finalObj.push(feedval >= 0 ? feedval : stage_ele[d_ele.key1]); // Push feed value if valid, otherwise use alternative key
              }
              const concval = stage_ele.conc_ppm[d_ele.key1]; // Get the permeate value from conc_ppm (note: variable name seems swapped)
              constValue.push(concval >= 0 ? concval : stage_ele[d_ele.key1.replace('feed', 'conc')]); // Push permeate value if valid, otherwise use alternative key with 'perm' replacement
              if (aggregatedTotalData.split_flow && stage_ind === 0) {
                const upstream = ro_output_data[ele].output_user.split[d_ele.key3][d_ele.key2];
                permValue.push(upstream); // Push concentrate value if valid, otherwise use alternative key with 'conc' replacement
              }
              const permval = stage_ele.perm_ppm[d_ele.key1]; // Get the concentrate value from perm_ppm (note: variable name seems swapped)
              permValue.push(permval >= 0 ? permval : stage_ele[d_ele.key1.replace('feed', 'perm')]); // Push concentrate value if valid, otherwise use alternative key with 'conc' replacement
            });
            finalObj.push(...constValue); // Spread and add all permeate values to the final object
            finalObj.push(...permValue); // Spread and add all permeate values to the final object
            finalObj.push(downStream[d_ele.key3][d_ele.key2]); // Add the total value from stream output data
            return finalObj; // Return the complete row array
          });
          return ( // Return the JSX for rendering the table
            <View break key={`a${String(Math.random()).substring(2, 7)}`} style={{ width: RationValWidth(tablewidth), margin: '15 auto 0 auto' }}> {/* Create a page-breakable view with random key and centered width */}
              <View wrap> {/* Create a wrappable view container */}
                <View style={[membraneStyle.textHeader, { flexDirection: 'row' }]}> {/* Create header row with flex direction */}
                  <Text style={{ paddingLeft: 0 }}>{serialNum}.{subSerialNum}.{++ro_hp_ind}</Text> {/* Display section numbering with incremented ro_hp_ind */}
                  <Text style={{ paddingLeft: 5, ...(langualgeCheck ? { fontFamily: ChineseFonts } : {}) }}>{ele} {translateObject('Aggregate Stream Summary')} </Text> {/* Display element name and translated title with conditional Chinese font */}
                </View>
                <View style={[membraneStyle.mainTable, { marginTop: 10 }]}> {/* Create main table container with top margin */}
                  <View fixed> {/* Create fixed header section that stays on each page */}
                    <View style={[membraneStyle.tableRow, membraneStyle.tableCol]}> {/* Create table row for title */}
                      <Text style={[membraneStyle.tableCell, membraneStyle.restChild, langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }]}>{translateObject('Concentrations (mg/L as ion)')}</Text> {/* Display translated concentrations title with conditional font */}
                    </View>
                    <TableHeader langualgeCheck={langualgeCheck} translateObject={translateObject} tableWidth={tablewidth} headerval={table2Header} /> {/* Render table header component with props */}
                  </View>
                  <View> {/* Create container for table body rows */}
                    {elemRowData.map((aggr_data, aggr_ind) => { // Map through each row of data
                      return ( // Return JSX for each row
                        <View style={[ // Create row container with conditional bottom border
                          { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, // Set flex properties for row layout
                          elemRowData.length - 1 === aggr_ind ? { borderBottom: 0 } : { borderBottom: 1, borderColor: '#002D62' } // Remove bottom border for last row, add border for others
                        ]}>
                          {aggr_data.map((aggr_child, aggr_child_ind) => { // Map through each cell in the row
                            return ( // Return JSX for each cell
                              <View key={aggr_child_ind} style={[ // Create cell container with key and conditional right border
                                { width: RationValWidth(tablewidth / columnLength.length) }, // Calculate and set cell width based on total columns
                                aggr_child_ind === aggr_data.length - 1 ? { borderRight: 0 } : { borderRight: 1, borderColor: '#002D62' } // Remove right border for last cell, add border for others
                              ]}>
                                <Text style={[membraneStyle.tableCell, { margin: '0 auto', padding: '3 0' }, langualgeCheck && { fontFamily: ChineseFonts }]}> {/* Create text element with cell styling and conditional Chinese font */}
                                  {Object.prototype.toString.call(aggr_child) === '[object String]' ? // Check if the value is a string
                                    aggr_child : aggr_child.toFixed(2)} {/* Display string as-is, or format number to 2 decimal places */}
                                </Text>
                              </View>
                            );
                          })}
                        </View>
                      );
                    })}
                  </View>
                </View>
              </View>
            </View>
          );
        }
      })}
    </View>
  );
};
export default ROStageLevelSummary;